<template>
  <!-- 企业账号与安全 -->
  <div class="firm-body">
    <!-- 标题 企业中心 账号与安全 -->
    <div class="title-Individual-center">
      企业中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">账号与安全</span>
    </div>
    <!-- 主体部分 -->
    <div class="firm-Content-subject">
      <!-- 切换 -->
      <div class="Toggle">
        <div
          v-for="(item, index) in selectArr"
          :key="index"
          class="clickable-item"
          :class="select == item.id ? 'select-p' : ''"
          @click="handelSelect(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- 不同模块 -->
      <div class="imparity-module">
        <ModuleOne v-if="select == '1'"></ModuleOne>
        <ModuleTwe v-if="select == '2'"></ModuleTwe>
        <ModuleThree v-if="select == '3'"></ModuleThree>
      </div>
    </div>
  </div>
</template>

<script>
// 引入模块
import ModuleThree from "./components/ModuleThree.vue";
import ModuleTwe from "./components/ModuleTwe.vue";
import ModuleOne from "./components/ModuleOne.vue";

export default {
  data() {
    return {
      selectArr: [
        { name: "账号管理", id: "1" },
        { name: "企业安全管理", id: "2" },
        { name: "权限管理", id: "3" },
      ],
      select: "1", // 筛选
    };
  },
  watch: {
    // 监听路由对象中 query 里的 key
    "$route.query.key"(newVal) {
      if (newVal) {
        this.select = newVal;
      }
    },
  },
  components: {
    ModuleOne,
    ModuleTwe,
    ModuleThree,
  },
  created() {
    const user = this.$store.getters.getUser;
    const company = this.$store.getters.getCompany;
    // 未登录预览：保留完整 Tab 布局；已登录非创建人只保留账号管理
    if (user && user.id && user.id != company.createBy) {
      this.selectArr = this.selectArr.slice(0, 1);
    }

    // 路由参数赋值
    if (this.$route.query.key) {
      this.select = this.$route.query.key;
    }
  },
  methods: {
    // 筛选切换
    handelSelect(num) {
      this.select = num;
    },
  },
};
</script>

<style scoped lang="less">
.firm-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .firm-Content-subject {
    width: 100%;
    min-height: 540px;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    // 切换
    .Toggle {
      width: 100%;
      height: 30px;
      display: flex;
      color: #333333;
      text-align: center;
      font-weight: 400;
      .clickable-item:nth-child(1) {
        margin-left: 20px;
      }
      .clickable-item {
        margin-right: 40px;
        font-size: 16px;
        cursor: pointer;
      }
      .select-p {
        color: #409eff ;
        box-sizing: border-box;
        border-bottom: 2px solid #409eff ;
      }
    }
    // 不同模块切换
    .imparity-module {
      width: 100%;
      min-height: 100px;
      margin-top: 30px;
    }
  }
}
</style>
